/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-18 15:10:57
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-07 12:45:04
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/slice/index.ts
 * @LastEditTime: 2021-03-23 22:28:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/slice/index.ts
 */

import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { msg } from 'src/tools/message';
import { convertDataFromServerToRedux } from '../tools';

import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getLoaded as _getLoaded,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
} from 'src/pages/SalesChannelContentEditor/slice/selectors';

import {
  getContent404Page,
  postContent404Page,
} from '@/src/request/salesChannel/content';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  EnumCollapseId,
  fixedCollapse,
  generateDefaultButtonText,
  generateDefaultContentSetting,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditor404Page/common';
import {
  generateDefaultState as _generateDefaultState,
  //hasError,
  onCollapseOpen as _onCollapseOpen,
  assData,
  defaultStatus,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
export { EnumCollapseId };
export const request_get404Page = createAsyncThunk(
  'fetchSalesChannelContent404Page',
  async (data: any) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getContent404Page(uuid, params || {});
    return { response, isPrimary, isClone };
  },
);

export const request_submit = createAsyncThunk(
  'submitSalesChannelContent404Page',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await postContent404Page(body, params || {});
    return { response, isPrimary };
  },
);

// const _defaultContent = {
//   buttonText: generateDefaultButtonText(),
//   contentSetting: generateDefaultContentSetting(),
// };

const _defaultState = _generateDefaultState(fixedCollapse);

const defaultState = {
  ..._defaultState,
  ...defaultStatus,
  defaultContentSetting: generateDefaultContentSetting(),
  defaultButtonText: generateDefaultButtonText(),
};

const salesChannelContent404Page = createSlice({
  name: 'salesChannelContent404Page',
  initialState: defaultState,
  reducers: {
    onContentSettingChange: (state, action) => {
      state.hasModified = true;

      state.contentSetting = { ...state.contentSetting, ...action.payload };
    },
    onButtonTextChange: (state, action) => {
      state.hasModified = true;
      state.buttonText.text = action.payload;
    },
    onFeatureProductsChange: (state, action) => {
      state.hasModified = true;
      state.featureProduct.titleTextColor = action.payload;
    },
    onButtonThemeChange: (state, action) => {
      state.hasModified = true;
      state.buttonText.buttonThemeUuid = action.payload;
    },
    onCollapseOpen: (state, action) => {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },
    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    resetButtonText: (state) => {
      state.hasModified = true;
      state.buttonText = { ...state.defaultButtonText, display: true };
    },
    resetContentSetting: (state) => {
      state.hasModified = true;
      state.contentSetting = { ...state.defaultContentSetting, display: true };
    },
    resetStaticConfig: (state) => {
      state.openList = [];
    },
    resetAll: (state) => {
      assData(state, defaultState);
    },
    validation: (state) => {
      const hasError =
        !state.contentSetting.text ||
        !state.contentSetting.image ||
        !state.buttonText.text;
      state.isDataValid = !hasError;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(request_get404Page.pending, (state) => {
      state.loading = true;
      state.loaded = false;
    });
    builder.addCase(request_get404Page.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;
      const data = convertDataFromServerToRedux(response) || {};
      state.loading = false;
      assData(state, data);
      if (isClone) state.hasModified = true;
    });
    builder.addCase(request_get404Page.rejected, (state) => {
      const data = convertDataFromServerToRedux({});
      assData(state, data);
      state.loading = false;
      state.loaded = true;
    });
    builder.addCase(request_submit.pending, (state, action) => {
      state.loaded = false;
    });
    builder.addCase(request_submit.rejected, (state, action) => {
      state.loaded = true;
    });
    builder.addCase(request_submit.fulfilled, (state, action) => {
      const { response, isPrimary } = action.payload;
      const data = convertDataFromServerToRedux(response, isPrimary) || {};
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      assData(state, data);
      state.hasModified = false;
    });
  },
});

export const getContentSetting = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.notFoundPage.contentSetting,
    (v) => v,
  );
};

export const getFeatureProduct = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.notFoundPage.featureProduct,
    (v) => v,
  );
};

export const getButtonText = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.notFoundPage.buttonText,
    (v) => v,
  );
};

export const getHasModified = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.notFoundPage.hasModified,
    (hasModified) => {
      return hasModified;
    },
  );
};

export const getSalesChannelContent = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.notFoundPage.salesChannelContent,
    (v) => v,
  );
};

export const getSalesChannelName = () => {
  return createSelector(
    (state: Record<string, any>) =>
      state.salesChannelContent.notFoundPage.salesChannelName,
    (v) => v,
  );
};

export const getOpenList = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.notFoundPage.openList,
    (v) => v,
  );
};

export const getLoading = () => {
  return createSelector(
    (state: any) => state.salesChannelContent.notFoundPage.loading,
    (v) => v,
  );
};

export const getState = () => {
  return _getState(EnumReducers.notFoundPage);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.notFoundPage, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.notFoundPage, id);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.notFoundPage);
};
export const getLoaded = () => {
  return _getLoaded(EnumReducers.notFoundPage);
};

export const {
  onContentSettingChange,
  onButtonTextChange,
  onFeatureProductsChange,
  onCollapseOpen,
  resetButtonText,
  resetContentSetting,
  resetStaticConfig,
  resetAll,
  validation,
  onButtonThemeChange,
  onErrorChange,
} = salesChannelContent404Page.actions;

export default salesChannelContent404Page.reducer;
